import appendQuery from 'append-query'

export const bridgeEvent = {
  navigate: 'ytx:navigate',
  action: 'ytx:actionInfo',
  share: 'ytx:share',
  setshare: 'ytx:setShare', // 设置标题右上角分享按钮
  destory: 'ytx:destroy', // 销毁webview
  parameter: 'ytx:parameter',
}
export const actionType = {
  login: 5, // 跳转登录
  quote: 8, // 行情股票点击跳转 、旗舰板块
  mentor: 9, // ql文字直播作者点击跳转
  QLmodule: 10, // 模块（类）点击跳转
  navigate: 11,//旗舰 跳 ytx
  qlpause: 18, //擒龙 ios 暂停 安卓关闭
  qjpause: 12, // 暂停
  savePic: 28, // 保存图片
  titleOptions: 29, // 只设置标题
  getNativeTopHeight: 36, // 获取原生顶部高度
  course: 37, // 只设置标题
  back: 67, // 后退
  goBack: 24, //关闭web页
  open_webviewQL: 75, // 开启新webview内容浏览器
  zzltTitleChange: 16,//修改头部
  popUpCommentInput: 19, // 弹评论输入框
  video: 102,//视频组件传递宽高
  toQLCourse: 72,//擒龙课程
  toQJCourse: 73,//旗舰课程
  toQLVideo: 73, // ql去视频直播室
  toVideo: 81, //擒龙原生视频详情页
  getLevelDot: 54, // 客户端传给h5的页面打点参数
  changeBarColor: 82, // 修改状态栏字体的颜色 isWhite 1-白色 0或者不传为黑色
  loginAndCloseWebview: 35, // 跳转登录，登录成功过后，关闭当前webview 跳转url 擒龙课程
  globalInfo: 103,// 获取globalInfo
  coloums: 42,// 擒龙栏目
  adver: 40,//跳原生
}

let countNum = 3

const processData = {
  [bridgeEvent.navigate]: (data) => {
    return {
      schema: appendQuery(data.schema, data.data),
    }
  },
  [bridgeEvent.action]: (data) => data,
}

export const actionTo = (actionType, data = '', callback) => {
  console.log('actionTo>>>', actionType, data)
  fireEvent(bridgeEvent.action, {
    actionType,
    data,
    callback
  })
}

export const navigateTo = (schema, data = '', callback) => {
  fireEvent(bridgeEvent.navigate, {
    schema,
    data,
    callback
  })
}


function bridgeSuccess(callback) {
  if (window.YTXBridge) {
    callback && callback()
  } else {
    if (countNum <= 0) return
    let timer = setTimeout(() => {
      clearTimeout(timer)
      timer = null
      bridgeSuccess(callback)
      countNum--
    }, 200)
  }
}

export function fireEvent(event, data, callback) {
  let eventData
  if (['ytx:wechat', 'ytx:share'].includes(event)) {
    eventData = data
  } else {
    eventData = processData[event](data)
  }
  if (callback) {
    eventData.callback = callback
  }
  bridgeSuccess(() => {
    console.info('js bridge event:', event, 'data:', eventData)
    window.YTXBridge && window.YTXBridge.fireEvent(event, eventData)
  })
}

export default {
  actionType,
  bridgeEvent,
  actionTo,
  fireEvent,
  navigateTo
}